<template>
  <div class="page">
    <div class="top"></div>
    <div class="google-btn">
      <div class="google-btn-left"></div>
      <div class="google-btn-center the-war2-btn" @click="goLink"></div>
      <div class="google-btn-right"></div>
    </div>
    <div class="center"></div>
    <div class="footer">
      <div class="footer-left"></div>
      <div class="footer-right the-war2-btn" @click="goLink"></div>
    </div>
  </div>
</template>

<script>
import { analysis } from '../global/js/analysis'
export default {
  name: 'Index',
  data() {
    return {
      link_list: {
        naver: 'https://game.naver.com/lounge/REALM_OF_DEITY/home',
        google:
          'https://play.google.com/store/apps/details?id=com.hookylin.kr.qyz.google',
        store: 'https://onesto.re/_1FODc1Z'
      }
    }
  },
  methods: {
    /**跳转链接 */
    goLink() {
      window.gtag('event', '订阅', {
      send_to: 'AW-11153587018/xE6nCMXc-ZoYEMr2uMYp'
      })
      window.open('https://thewar.onelink.me/p5sf/06ybh8eu', '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  overflow-x: hidden;
}
.top,
.center,
.footer-left,
.footer-right {
  width: 100%;
  height: 100%;
  background-size: 100% 100% !important;
  background-repeat: no-repeat;
  background-position: center;
}
.top {
  position: relative;
  background-size: cover;
  background: url('../assets/images/top.gif');
  max-height: 12rem;
}
.center {
  max-height: 9rem;
  background: url(../assets/images/center.png);
  margin-bottom: 1rem;
}
.footer-left {
  flex: 1;
  background: url('../assets/images/footer-left.png');
}
.footer-right {
  max-width: 3.5rem;
  background: url('../assets/images/footer-right.gif');
}
.google-btn {
  width: 100%;
  height: 1.8rem;
  background-size: 100% 100% !important;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: row;
  &-left {
    width: calc((100% - 5rem) /2);
    background-size: 100% 100% !important;
    background: url('../assets/images/google-btn-bg.png');
  }
  &-center {
    height: 100%;
    background-size: 100% 100% !important;
    width: 5rem;
    background: url('../assets/images/google-pay.gif');
  }
  &-right {
    flex: 1;
    background-size: 100% 100% !important;
    background: url('../assets/images/google-btn-bg2.png');
  }
}
.footer {
  display: flex;
  height: 1.5rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1;
}
</style>
